import { render, staticRenderFns } from "./sider-bar-mini.vue?vue&type=template&id=e276ab48&"
import script from "./sider-bar-mini.vue?vue&type=script&lang=js&"
export * from "./sider-bar-mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports